import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Box } from "@mui/material";

import { RETRIEVE_FROM_QBO_OPTIONS } from "appConfig";

import { ActionButton } from "components/ActionButton";
import { FrmSelectFromObjects } from "components/formFields/FrmSelectFromObjects";
import { GroupingBox } from "components/utility/GroupingBox";
import { HoverHelp } from "components/utility/HoverHelp";

import { i18n } from "services/i18nService";
import { retrieveFromQbo } from "services/sosInventoryService/sosApi";

import { openAlert } from "globalState/alertSlice";
import {
  loadingIndicatorOn,
  loadingIndicatorOff,
} from "globalState/loadingSlice";

export function RetrieveFromQbo() {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.loading.list);

  const [objectType, setObjectType] = useState(null);

  async function handleRetrieveFromQbo() {
    dispatch(loadingIndicatorOn());
    const { success, message } = await retrieveFromQbo(objectType.id);
    if (success) {
      const message = i18n("dataUtilities.UpdateHistoricalCostsStarted");
      dispatch(openAlert({ type: "success", message }));
    } else {
      const errorMessage = message || i18n("error.UpdatingHistoricalCost");
      dispatch(openAlert({ type: "error", message: errorMessage }));
    }
    dispatch(loadingIndicatorOff());
  }

  return (
    <GroupingBox
      variant="borderLabelMedium"
      heading={i18n("dataUtilities.RetrieveFromQuickBooks")}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1, mr: 1 }}>
        <ActionButton
          sx={{ width: "8rem" }}
          onClick={handleRetrieveFromQbo}
          disabled={isLoading}
        >
          {i18n("dataUtilities.Retrieve")}
        </ActionButton>

        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <FrmSelectFromObjects
            fullWidth
            label={i18n("global.Type")}
            value={objectType}
            onValueChange={(_, e) => setObjectType(e)}
            options={RETRIEVE_FROM_QBO_OPTIONS}
            minWidth="14rem"
          />
          <HoverHelp title={i18n("dataUtilities.Retrieve.hoverHelp")} />
        </div>
      </Box>
    </GroupingBox>
  );
}
